import { render } from "./ResetPinComponent.html?vue&type=template&id=e596d764&scoped=true&external"
import script from "./ResetPinComponent.vue?vue&type=script&lang=js"
export * from "./ResetPinComponent.vue?vue&type=script&lang=js"

import "./ResetPinComponent.scss?vue&type=style&index=0&id=e596d764&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e596d764"]])

export default __exports__